import { useRouter } from '../context/RouterContext';
import AppHeader from '../components/AppHeader';

function DatabasePage() {
  const { navigate } = useRouter();

  return (
    <div className="landing-page">
      <AppHeader showBackButton={true} />

      <main className="landing-main">
        <h1 className="landing-title">Access Database</h1>
        <p className="landing-subtitle">Under Maintenance</p>
        <p style={{ color: '#6b7280', marginBottom: '2rem' }}>
          This section provides access to credit deals, capital providers, and fintech borrowers data.
        </p>
        <button 
          onClick={() => navigate('/')}
          style={{
            padding: '12px 24px',
            background: '#1a1a1a',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ← Back to Home
        </button>
      </main>
    </div>
  );
}

export default DatabasePage;
